<template>
  <div>
    <slot></slot>
    <Row>
      <div style="text-align: right">
        <div class="filter-wrapper">
          <Button @click="isShow=!isShow" >
            列
            <Icon v-if="isShow" type="ios-arrow-up"></Icon>
            <Icon v-else type="ios-arrow-down"></Icon>
          </Button>

          <div class="filter-bg" style="z-index: 999" @click.self="isShow=false" v-if="isShow">
          </div>
          <div class="filter" v-if="isShow" style="line-height: 1.7">
            <Input type="text" icon="ios-search" size="small" v-model="keyText"/>
            <Button @click.stop="backDefault" size="small" style="margin: 5px 0 " v-if="!keyText">恢复默认</Button>
<!--            <Button v-if="hasSave" size="small" @click.stop="saveConfig">保存配置</Button>-->

            <Checkbox class="block" v-model="isCheckAll" v-if="!keyText">全选</Checkbox>
            <CheckboxGroup v-model="dataChecked">
              <Checkbox class="block" v-for="(item,index) in columnsCheck" :label="item.key" :key="'keyA'+index">{{item.title}}</Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </Row>
    <Row :gutter="16">
      <!-- <Col :span="slotSpan">
        <slot></slot>
      </Col> -->
      <Col :span="tableSpan">
        <Table :columns="columnsTable" :data="data" :loading="loading" @on-selection-change="select"
               @on-select="onSelect"
               ref="table"></Table>
        <div style="overflow:hidden" v-if="showPage">
          <Page :total="total" :size="size" :current="current" show-total transfer @on-change="changePage"
                @on-page-size-change="changeSize" class="mt20 fr"></Page>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script type="text/ecmascript-6">
  import {deepClone} from '../../utils/format'
  export default {
    props: {
      name: "FilterTableList",
      defaultColumns: {
        type: Array,
        default: null
      },
      columns: {
        type: Array,
        default: null
      },
      data: {
        type: Array,
        default: null
      },
      total: {
        type: Number,
        default: 0
      },
      size: {
        type: String,
        default: "small"
      },
      loading: {
        type: Boolean,
        default: false
      },
      current: {
        type: Number,
        default: 1
      },
      tableSpan: {
        type: Number,
        default: 24
      },
      showPage: {
        type: Boolean,
        default: true
      },
      slotSpan: {
        type: Number,
        default: 24
      },
      mt36: {
        type: Boolean,
        default: true
      },
      hasSave:{
        type:Boolean,
        default:false
      },
      cacheKey:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        isShow: false,
        dataChecked: [],
        keyText: '',
        indeterminate:true
      }
    },
    watch:{
      columnsTable(value){
        if(!value.length || !this.cacheKey){
          return
        }
        localStorage.setItem(this.cacheKey,JSON.stringify(this.dataChecked))

      }

    },
    computed: {
      isCheckAll:{
        get:function () {
          return this.dataChecked.length==this.columnsCheck.length
        },
        set:function(value){
          if (value) {
            this.checkAllValues()
          }
          else {
            this.clearValues()
          }
        }
      },
      columnsTable() {
        return this.columns.filter((ele) => {
          return (ele.key&&ele.title)?this.dataChecked.indexOf(ele.key) !== -1:true
        })
      },
      validColumns() {  //checkGroup中所有可选的列
        return this.columns.filter((ele) => {
          return ele.key && ele.title
        })
      },
      columnsCheck() {
        if (!this.keyText) {
          return this.validColumns
        }
        return this.validColumns.filter((ele) => {
          return ele.title.indexOf(this.keyText) !== -1
        })
      }
    },
    methods: {
      saveConfig(){

      },

      backDefault(){   //恢复默认设置
        if(this.defaultColumns!=null && this.defaultColumns.length>0){
          this.dataChecked=deepClone(this.defaultColumns)
        }
        else {
          this.checkAllValues()
        }
      },
      clearValues() {
        this.dataChecked = []
      },
      checkAllValues() {
        this.dataChecked=[]
        this.validColumns.forEach((ele) => {
          this.dataChecked.push(ele.key)
        })
      },
      changePage(n) {
        this.$emit("change-page", n);
      },
      changeSize(size) {
        this.$emit("change-size", size);
      },
      select(selection, row) {
        this.$emit("on-selection-change", selection, row);
      },
      onSelect(selection, row) {
        this.$emit("on-select", selection, row);
      },
    },
    created() {
      let f=(this.defaultColumns==null|| this.defaultColumns.length==0)
      if(f){
        this.checkAllValues()
      }
      else {
        let cache=this.cacheKey?JSON.parse(localStorage.getItem(this.cacheKey)):[]
        this.dataChecked=(cache&&cache.length)?cache:this.defaultColumns

        // this.dataChecked=this.defaultColumns
      }
    }
  };
</script>
<style scoped>
  .filter-wrapper {
    position: relative;
    display: inline-block;
    text-align: left;
  }
  .filter-bg{
    /*background-color: #CFA868;*/
    position: fixed;
    height: 100vh;
    right: 0;
    width: 100vw;
    top: 0;
  }

  .filter {
    border: 1px solid rgb(220, 220, 220);
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    z-index: 1000;
    width: 160px;
    background-color: white;
    max-height: 500px;
    overflow: auto;
  }

  .block {
    display: block;
  }

</style>

